var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DraggableType, DroppableType } from '@data/dragAndDrop/types';
import { useTagActions } from '@data/tag/tagActions';
import { useCallback } from 'react';
import { useFinder } from '../../shared/finder/useFinder';
import { useSheetRowActions, useSheetRowPath, useSheetRowsById, useSheetRowsByParentId, } from '../sheetRow/sheetRowHooks';
import { useTagContext } from '../tag/tagContext';
export function useFinderToFinderHandler() {
    var _this = this;
    var sheetRowPath = useSheetRowPath();
    var tagData = useTagContext().tagData;
    var reorderTags = useTagActions().reorderTags;
    var sheetRowsById = useSheetRowsById();
    var sheetRowsByParentId = useSheetRowsByParentId();
    var finderColumns = useFinder(sheetRowPath, { tagMap: tagData.tagById, sheetRowMap: sheetRowsById });
    var _a = useSheetRowActions(), dndChangeSheetRowParent = _a.dndChangeSheetRowParent, dndReorderSheetRows = _a.dndReorderSheetRows;
    return useCallback(function (sourceInfo, targetInfo, draggableInfo, combineDraggableInfo, targetIndex) { return __awaiter(_this, void 0, void 0, function () {
        var targetIdx, sheetRowPath, tagId, clusterId, parentPath_1, parentId, parentFinderColumn, finderColumnItems, left, right, leftItem, rightItem, parentPath, parentId, children;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    targetIdx = targetIndex !== null && targetIndex !== void 0 ? targetIndex : 0;
                    // source, target and draggable checks
                    if (sourceInfo.type !== DroppableType.Finder ||
                        targetInfo.type !== DroppableType.Finder ||
                        draggableInfo.type !== DraggableType.Cluster) {
                        return [2 /*return*/, { status: 'error' }];
                    }
                    sheetRowPath = draggableInfo.sheetRowPath, tagId = draggableInfo.tagId;
                    clusterId = Number.parseInt((_a = sheetRowPath.split('_').pop()) !== null && _a !== void 0 ? _a : '');
                    if (Number.isNaN(clusterId)) {
                        // no cluster id found in path
                        return [2 /*return*/, { status: 'error', message: 'Cluster not found' }];
                    }
                    if (!(combineDraggableInfo === undefined)) return [3 /*break*/, 10];
                    parentPath_1 = targetInfo.sheetRowPath;
                    parentId = Number.parseInt((_b = parentPath_1.split('_').pop()) !== null && _b !== void 0 ? _b : '');
                    if (Number.isNaN(parentId)) {
                        // no parent found in path
                        return [2 /*return*/, { status: 'error', message: 'Parent cluster not found' }];
                    }
                    parentFinderColumn = finderColumns.find(function (c) { return c.path === parentPath_1; });
                    finderColumnItems = (_c = parentFinderColumn === null || parentFinderColumn === void 0 ? void 0 : parentFinderColumn.items) !== null && _c !== void 0 ? _c : [];
                    if (!(sourceInfo.sheetRowPath !== targetInfo.sheetRowPath)) return [3 /*break*/, 2];
                    // dragging cluster to new parent
                    return [4 /*yield*/, dndChangeSheetRowParent(clusterId, parentId, targetIdx)];
                case 1:
                    // dragging cluster to new parent
                    _f.sent();
                    return [3 /*break*/, 9];
                case 2:
                    if (!(tagId !== undefined && !Number.isNaN(tagId))) return [3 /*break*/, 7];
                    left = 0;
                    right = finderColumnItems.length - 1;
                    while (left !== right) {
                        leftItem = finderColumnItems[left];
                        rightItem = finderColumnItems[right];
                        if (leftItem.clusterId === rightItem.clusterId) {
                            break;
                        }
                        if (leftItem.clusterId !== clusterId) {
                            left++;
                        }
                        if (rightItem.clusterId !== clusterId) {
                            right--;
                        }
                    }
                    if (!(targetIdx > right || targetIdx < left)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dndReorderSheetRows(clusterId, parentId, targetIdx)];
                case 3:
                    _f.sent();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, reorderTags(finderColumnItems, tagId, targetIdx)];
                case 5:
                    _f.sent();
                    _f.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7: 
                // reordering normal cluster
                return [4 /*yield*/, dndReorderSheetRows(clusterId, parentId, targetIdx)];
                case 8:
                    // reordering normal cluster
                    _f.sent();
                    _f.label = 9;
                case 9: return [3 /*break*/, 12];
                case 10:
                    if (combineDraggableInfo.type !== DraggableType.Cluster) {
                        // cluster was dragged to something else, not another cluster
                        return [2 /*return*/, { status: 'error' }];
                    }
                    parentPath = combineDraggableInfo.sheetRowPath;
                    parentId = Number.parseInt((_d = parentPath.split('_').pop()) !== null && _d !== void 0 ? _d : '');
                    if (Number.isNaN(parentId)) {
                        // no parent found in path
                        return [2 /*return*/, { status: 'error', message: 'Parent cluster not found' }];
                    }
                    if (parentId === clusterId) {
                        // dragged and target cluster are the same
                        return [2 /*return*/, { status: 'error' }];
                    }
                    children = sheetRowsByParentId[parentId];
                    return [4 /*yield*/, dndChangeSheetRowParent(clusterId, parentId, (_e = children === null || children === void 0 ? void 0 : children.length) !== null && _e !== void 0 ? _e : 0)];
                case 11:
                    _f.sent();
                    _f.label = 12;
                case 12: return [2 /*return*/, { status: 'success' }];
            }
        });
    }); }, [finderColumns, reorderTags]);
}
